/* global axios */
import ApiClient from './ApiClient';

class IvrVoicesAPI extends ApiClient {
  constructor() {
    super('ivr/voices', { accountScoped: true });
  }

  // GET /api/v1/accounts/:account_id/ivr/voices
  get(params = {}) {
    return axios.get(this.url, { params });
  }

  // GET /api/v1/accounts/:account_id/ivr/voices/:id
  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  // POST /api/v1/accounts/:account_id/ivr/voices/preview
  preview(data) {
    return axios.post(`${this.url}/preview`, data, {
      responseType: 'blob',
    });
  }

  // GET /api/v1/accounts/:account_id/ivr/voices/models
  getModels() {
    return axios.get(`${this.url}/models`);
  }

  // GET /api/v1/accounts/:account_id/ivr/voices/subscription
  getSubscription() {
    return axios.get(`${this.url}/subscription`);
  }

  // GET /api/v1/accounts/:account_id/ivr/voices/api_key_status
  getApiKeyStatus() {
    return axios.get(`${this.url}/api_key_status`);
  }

  // POST /api/v1/accounts/:account_id/ivr/voices/test_api_key
  testApiKey(apiKey) {
    return axios.post(`${this.url}/test_api_key`, { api_key: apiKey });
  }

  // POST /api/v1/accounts/:account_id/ivr/voices/save_api_key
  saveApiKey(apiKey) {
    return axios.post(`${this.url}/save_api_key`, { api_key: apiKey });
  }
}

export default new IvrVoicesAPI();
